module.exports = __webpack_public_path__ + "static/erikfloresq-397d43ff9272fb56fb56da5a2411eae1.png";